module.exports = __webpack_public_path__ + "EmoTip-f8571dad90b9b2264208113b1f3e9718.png";